import { render, staticRenderFns } from "./OnboardingVerificationDomainModal.vue?vue&type=template&id=5da8a591&scoped=true"
import script from "./OnboardingVerificationDomainModal.vue?vue&type=script&lang=js"
export * from "./OnboardingVerificationDomainModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingVerificationDomainModal.vue?vue&type=style&index=0&id=5da8a591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da8a591",
  null
  
)

export default component.exports